import React from 'react';
import { useLocation } from 'react-router-dom';
import Navbar from './Navbar';

const Layout = ({ children }) => {
  const location = useLocation();
  const hideNavbar = location.pathname.startsWith('/share/');

  return (
    <div className="min-h-screen bg-gray-50">
      {!hideNavbar && <Navbar />}
      <main className={hideNavbar ? '' : 'pt-16'}>
        {children}
      </main>
    </div>
  );
};

export default Layout;